import React from "react";
import Round from "../../assets/svgs/Round.svg";
import Marquise from "../../assets/svgs/Marquise.svg";
import Radiant from "../../assets/svgs/Radiant.svg";
import Heart from "../../assets/svgs/Heart.svg";
import Asscher from "../../assets/svgs/Asscher.svg";
import Pear from "../../assets/svgs/Pear.svg";
import Emerald from "../../assets/svgs/Emerald.svg";
import Oval from "../../assets/svgs/Oval.svg";
import Cushion from "../../assets/svgs/Cushion.svg";
import Princess from "../../assets/svgs/Princess.svg";
import { useDispatch, useSelector } from "react-redux";
import { removeFromFilter, updateFilter } from "../../store/slices/filterSlice";
const DimonShapes = () => {
  const diamondShapes = [
    { name: "ROUND", img: Round },
    { name: "MARQUISE", img: Marquise },
    { name: "RADIANT", img: Radiant, subTypes: ["RADIANT", "RADIANT CUT"] },
    {
      name: "HEART",
      img: Heart,
      subTypes: ["HEART", "HEART MODIFIED BRILLIANT"],
    },
    { name: "ASSCHER", img: Asscher },
    { name: "PEAR", img: Pear },
    { name: "EMERALD", img: Emerald },
    { name: "OVAL", img: Oval },
    {
      name: "CUSHION",
      img: Cushion,
      subTypes: [
        "BRILLIANT CUT",
        "CUSHION",
        "CUSHION BRILLIANT",
        "CUSHION MODIFIED",
        "CUT CORNERED RECTANGULAR",
        "MODIFIED BRILLIANT",
        "SQUARE",
        "SQUARE RADIANT",
        "SQUARE EMERALD CUT",
      ],
    },
    { name: "PRINCESS", img: Princess },
  ];
  const dispatch = useDispatch();
  const filterSelect = useSelector((state) => state?.filter);
  const handleAddFilter = (value, subTypes) => {
    dispatch(updateFilter({ key: "shape", value: value, subTypes }));
  };
  const handleRemoveFilter = (value, subTypes) => {
    dispatch(removeFromFilter({ key: "shape", value: value, subTypes }));
  };

  return (
    <div className="diamond-shap-container">
      {diamondShapes.map((shape, index) => (
        <div
          key={index}
          className={`list-item ${
            filterSelect?.shape?.includes(shape?.name) ? "active" : ""
          }`}
          onClick={() =>
            filterSelect?.shape?.includes(shape?.name)
              ? handleRemoveFilter(shape?.name, shape.subTypes)
              : handleAddFilter(shape?.name, shape.subTypes)
          }
        >
          <img src={shape.img} alt={shape.name} />
          <div className="shape-label">{shape.name}</div>
        </div>
      ))}
    </div>
  );
};

export default DimonShapes;
